declare const KindredAndroid: AndroidInterface | undefined;

export interface AndroidInterface {
  navigateToSettings(): void;
  close(): void;
  openExternalURL(url: string): void;
}

export const onExternalLinkClicked = (
  url: string,
  isEmbeddedInAndroid?: boolean
) => {
  if (isEmbeddedInAndroid) {
    if (
      typeof KindredAndroid !== 'undefined' &&
      KindredAndroid.openExternalURL
    ) {
      KindredAndroid.openExternalURL(url);
    } else {
      window.location.href = url;
    }
  }
};

export const onClose = () => {
  if (typeof KindredAndroid !== 'undefined' && KindredAndroid.close) {
    KindredAndroid.close();
  }
};

export const navigateToAndroidSettings = () => {
  if (
    typeof KindredAndroid !== 'undefined' &&
    KindredAndroid.navigateToSettings
  ) {
    KindredAndroid.navigateToSettings();
  }
};
